import _ from 'lodash'
import moment from 'moment'
import { deviceType } from '@/utils/common'
import { mapActions } from 'vuex'
window.moment = moment
export default {
  components: {
  },
  props: {
  },
  data () {
    return {
      hmInfo: { name: '' },
      hasInviteHMPermission: false
    }
  },
  computed: {
    isPc () {
      return deviceType.isPc
    },
    isEn () {
      return this.$i18n.locale === 'en'
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
    ...mapActions('hm', ['getHmInfo']),
    dealInterviewList (interviewList) {
      const todoList = []
      const doneList = []
      const interviewedList = []
      if (!interviewList) {
        return {
          todoList: todoList,
          doneList: doneList,
          interviewedList: interviewedList,
          totalCount: 0
        }
      }
      interviewList.forEach(element => {
        element.status = _.parseInt(element.status)
        if (
          element.status === 1 ||
          element.status === 2) {
          if (moment(element.start_time).isAfter()) {
            todoList.push(element)
          } else {
            interviewedList.push(element)
          }
        } else if (
          element.status === 3 ||
          element.status === 4) {
          doneList.push(element)
        }
      })

      function orderFunction (item) {
        return moment(item.start_time).valueOf()
      }

      return {
        todoList: _.orderBy(todoList, orderFunction),
        doneList: _.orderBy(doneList, orderFunction, ['desc']),
        interviewedList: _.orderBy(interviewedList, orderFunction, ['desc']),
        totalCount: 0
      }
    },
    dealRatingList (ratingList) {
      const todoList = []
      const doneList = []
      if (!ratingList) {
        return {
          todoList: todoList,
          doneList: doneList,
          totalCount: 0
        }
      }
      ratingList.forEach(element => {
        element.status = _.parseInt(element.status)
        if (element.status === 1) {
          element.status = 1
          todoList.push(element)
        } else if (element.status === 2 || element.status === 0) {
          doneList.push(element)
        }
      })

      function orderFunction (item) {
        return moment(item.created_time).format('x')
      }
      return {
        todoList: _.orderBy(todoList, orderFunction, ['desc']),
        doneList: _.orderBy(doneList, orderFunction, ['desc']),
        totalCount: 0
      }
    },
    showPreview (status, isInterview) {
      return isInterview && status === 2
    },
    showRate (status, isInterview) {
      return (isInterview && status === 1) || (!isInterview && (status === 1 || status === 3))
    },
    showView (status, isInterview) {
      return (isInterview && status === 3) || (!isInterview && status !== 1 && status !== 3)
    },
    showCancel (status, isInterview) {
      return isInterview && (status === 1 || status === 2)
    },
    showReschedule (status, isInterview) {
      return isInterview && (status === 1 || status === 2)
    },
    async initHmInfo () {
      const resp = await this.getHmInfo()
      this.hmInfo = {
        ...resp,
        name: resp.full_name
      }
      this.hasInviteHMPermission = _.includes(resp.permissions, 'PREMIUM_INVITE_HM_REVIEW')
      const newQuery = { ...this.$route.query, company_id: `${resp.root_company_id}` }
      if (JSON.stringify(newQuery) !== JSON.stringify(this.$route.query)) {
        this.$router.replace({ query: newQuery })
      }
    }
  },
  watch: {

  }
}
